import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "CargarDocsComponent"
  //Biometrics
  title: {
    fontWeight: 600,
    width: '90%',
    //outline: 'solid 1px tomato !important',
    alignSelf: 'center !important'
  },
  subtitle: {
    marginTop: '10px',
    width: '90%',
    alignSelf: 'center !important'
  },
  devicePic: {
    width: '100% !important',
    ['@media only screen and (max-width: 600px)']: {
      height: '50vh !important',
    },
    height: '50vh !important',
    //outline: 'solid 1px tomato !important',
    objectFit: 'scale-down !important',
    marginTop: '2vh'
  },
  enrollmentButtonHelp: {
    width: '100%',
    bottom: 0,
    position: 'absolute',
    alignSelf: 'center'
  },
  //Biometrics
}))